// removed by extract-text-webpack-plugin
module.exports = {"PopUp":"PopUp__PopUp___1q-IN","Background":"PopUp__Background___1y3lX","BackgroundOverlay":"PopUp__BackgroundOverlay___2-N1P","Content":"PopUp__Content___2P9_S","fadein":"PopUp__fadein___26xvt","Default":"PopUp__Default___zenlk","Close":"PopUp__Close____QuMY","Inverted":"PopUp__Inverted___4Xe2X"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PopUp/PopUp.scss
// module id = 1499
// module chunks = 0